export default {
  CREATE_AUTHOR(state, payload) {},
  GET_AUTHOR(state, payload) {
    state.author = payload;
  },
  EDIT_AUTHOR(state, payload) {},
  DELETE_AUTHOR(state, payload) {},
};
